import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=a60710fc&scoped=true&"
import script from "./ResultList.vue?vue&type=script&lang=js&"
export * from "./ResultList.vue?vue&type=script&lang=js&"
import style0 from "./ResultList.vue?vue&type=style&index=0&id=a60710fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60710fc",
  null
  
)

export default component.exports